import { API_CONFIG } from "config/api";

export interface OnboardingSubmitResult {
  success: boolean;
  message?: string;
  data?: {
    companyId: string;
    slug: string;
    status: string;
    contactEmail?: string;
  };
}

export async function submitEmployerOnboarding(
  formData: FormData
): Promise<OnboardingSubmitResult> {
  const response = await fetch(
    `${API_CONFIG.CUSTOMER.BASE_URL}${API_CONFIG.CUSTOMER.ENDPOINTS.ONBOARD_EMPLOYER}`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = (await response.json()) as OnboardingSubmitResult;
  if (!response.ok) {
    throw new Error(
      response.status >= 500
        ? "Unable to submit your application right now. Please try again later."
        : data.message || "Failed to submit application"
    );
  }
  return data;
}
